import Book from "./book";
import EpubCFI from "./epubcfi";
import Rendition from "./rendition";
import Contents from "./contents";
import Layout from "./layout";
import ePub from "./epub";

export default ePub;
export {
	Book,
	EpubCFI,
	Rendition,
	Contents,
	Layout
};



//////////////////
// WEBPACK FOOTER
// ./~/epubjs/src/index.js
// module id = 1516
// module chunks = 0